import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Layout,
  Menu,
  Breadcrumb,
  // theme,
  Avatar,
  Dropdown,
  Space,
  Divider,
  Badge,
  Popover,
  Spin,
} from "antd";
import type { MenuProps } from "antd";
import {
  UserOutlined,
  QuestionCircleOutlined,
  LogoutOutlined,
  SwapOutlined,
  // HomeOutlined,
  BellOutlined,
  // ExclamationCircleOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from "@ant-design/icons";
import { cloneDeep } from "lodash-es";
import "./index.less";
import api from "@/api";
import {
  BASE_SET_MENU,
  BASE_SET_LEFT_MENU,
  BASE_SET_AUTORIZE,
  BASE_SET_SYSTEM,
  BASE_SET_NOTIFICATIONS,
  BASE_SET_USER_DETAIL,
  BASE_SET_NOTIFICATION_OPEN,
} from "@/stores/base";
import { BASE_SYSTEM_ENUM } from "@/utils/base";
import actions from "@/stores/globalstate";
import {
  swapNavMode,
  getNavMode,
  CARD_MODE,
  MENU_MODE,
} from "@/utils/modeControl";
import MenuWorkbench from "@/components/Menu";
import Noticel from "../Noticel";
import encodeQuery from "@/utils/encodeQuery";
import { getSubAppUrl } from "@/config/microApp";
// import { Modal } from '@/components/BaseUI';
import { loginUrl, goLogin } from "@/utils/base";
import LogoKaihong from "@/assets/images/logo_kaihong.png";
import { initRender } from "@/index";
import NotifyInfo from "@/components/NotifyInfo";
import NetError from "./NetError";
import { filterHiddenMenuCodes } from "@/config";
import { onUserLogin } from "@/utils/beaconOtlp";
import { SYSTEM_CONFIG_FRONT_KEY } from "@/config";
import Token, { UserInfo } from "@/utils/token";
import { setConfigBusinessSwitch, FIELD_NAME_BUSINESS_SWITCH } from "@/config/businessSwitch";
import TenantSwitch from "@/components/RightContent/TenantSwitch";
import {
  filterGlobalTenantMenus,
  withTenantParam,
} from "@/utils/globalTenant";
import {
  findMenuChain,
  matchMenuUrl,
  CARD_MODE as MATCH_CARD_MODE,
} from "@/utils/menuMatch";
import { saveMenusCache } from "@/utils/menuCache";

const TWBasePrefixCls = "tw-base";
const { Header, Content, Sider } = Layout;

function Main(props: any) {
  const [collapsed, setCollapsed] = useState(false); // 左侧slider展开/收起状态
  const [openKeys, setOpenKeys] = useState<string[]>([]); // 左侧菜单展开的项
  const [topMenuSelectedKeys, setTopMenuSelectedKeys] = useState([]); // 头部导航选中的导航
  const [leftMenuSelectedKeys, setLeftMenuSelectedKeys] = useState([]); // 左侧菜单选中的菜单
  const [breadcrumbItems, setBreadcrumbItems] = useState<any[]>([]); // 面包屑数据
  const [menuType, setMenuType] = useState(""); // 工作台/菜单模式状态
  const [headData, setHeadData] = useState<any>({}); // 头部
  const [isLogin, setIsLogin] = useState(false);
  const [isNetError, setIsNetError] = useState(false); // 判断是否接口异常访问
  const [isNotify, setIsNotify] = useState(false); //license到期弹框
  const [notifyInfo, setNotifyInfo] = useState<string>(""); //license到期弹框内容

  // const { token: { colorBgContainer } } = theme.useToken();
  // const { modal } = App.useApp();
  const navigate = useNavigate();
  const location = useLocation();
  const menusRef = useRef<any[]>([]);
  const locationRef = useRef(location);
  const menuTypeRef = useRef(menuType);
  const latestSubAppBreadcrumbRef = useRef<any[]>([]);

  useEffect(() => {
    menusRef.current = props?.base?.menus || [];
  }, [props?.base?.menus]);

  useEffect(() => {
    locationRef.current = location;
  }, [location]);

  useEffect(() => {
    menuTypeRef.current = menuType;
  }, [menuType]);

  const navigateSubApp = (url: string) => {
    if (location.hash.includes("/khlinks")) {
      actions.setGlobalState({ hashPath: withTenantParam(url) });
    } else {
      navigate(withTenantParam(`/#/khlinks${url}`));
    }
  };

  /**
   * 登出
   */
  const handleClickLogout = async () => {
    await api.baseLogout();
    // 跳转路由到登录界面
    Token.remove(true);
    UserInfo.remove();
    if (!window.location.href.includes(loginUrl)) {
      goLogin();
    }
  };

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <a
          href="javascript: void(0)"
          onClick={() => navigateSubApp("/account/center")}
        >
          个人中心
        </a>
      ),
      icon: <UserOutlined />,
    },
    { type: "divider" },
    {
      key: "2",
      label: (
        <a
          href="javascript: void(0)"
          onClick={() => navigateSubApp("/helpCenter/guide")}
        >
          帮助中心
        </a>
      ),
      icon: <QuestionCircleOutlined />,
    },
    { type: "divider" },
    {
      key: "3",
      label: <div onClick={handleClickLogout}>退出登录</div>,
      icon: <LogoutOutlined />,
    },
  ];

  const onCollapse = (
    collapsed: boolean | ((prevState: boolean) => boolean)
  ) => {
    setCollapsed(collapsed);
    if (collapsed) {
      document.querySelector("#root")?.classList.add("menu-hide");
    } else {
      document.querySelector("#root")?.classList.remove("menu-hide");
    }
  };

  const getInitUrl: any = (menuList: any[]) => {
    // 优先取第一个可跳转的叶子菜单，避免第一个菜单没有 url 时取到空值
    const findFirstUrl = (nodes: any[] = []): string | undefined => {
      for (const node of nodes) {
        if (!node) {
          continue;
        }
        if (node.children?.length) {
          const childUrl = findFirstUrl(node.children);
          if (childUrl) {
            return childUrl;
          }
        }
        if (node.url) {
          return node.url;
        }
      }
      return undefined;
    };
    return findFirstUrl(menuList);
  };

  const getFilteredMenus = (menus: any[] = []) => {
    const filteredMenus = filterHiddenMenuCodes(menus);
    const visibleMenus = Array.isArray(filteredMenus) ? filteredMenus : [];
    // 全局租户模式（tenant=all）：只保留 PlatformOverview 及其指定子菜单
    return filterGlobalTenantMenus(visibleMenus);
  };

  /**
   * 获取用户菜单
   */
  const getBaseUserOwnTree = async () => {
    try {
      const params = {
        paging: false,
        terms: [
          {
            terms: [
              {
                terms: [
                  {
                    column: "owner",
                    termType: "eq",
                    value: "iot",
                  },
                  {
                    column: "owner",
                    termType: "isnull",
                    value: "1",
                    type: "or",
                  },
                ],
              },
            ],
          },
        ],
      };
      const res = await api.baseUserOwnTree(params);
      const { status, result } = res;
      if (status === 200) {
        // 同步菜单缓存：子应用按钮鉴权依赖 MENUS_BUTTONS_CACHE、code 反查路由依赖 MENUS_DATA_CACHE，
        // 原先只由 iot-web 在自身 render 时写入，未激活过 iot-web 就进其它子应用会取不到权限/路径。
        // 这里复用同一份接口数据（原始树，非过滤后的菜单）兜底写一次，必须在拉起子应用前完成。
        saveMenusCache(result);
        const filteredMenus = getFilteredMenus(result);
        const initUrl = getInitUrl(filteredMenus);
        console.log("initUrl", initUrl);
        // 成功
        setIsLogin(true);
        initRender(initUrl);
        props.setMenu(filteredMenus);
        // props.base.menus
      } else {
        props.setMenu([]);
      }
    } catch (error: any) {
      const { response } = error;
      // 限定5xx错误为网络错误
      if (String(response?.status).startsWith("5")) {
        setIsNetError(true);
      }
      console.error(error);
    }
  };

  /**
   * 获取用户基本信息
   */
  const getBaseAutorizeMe = async () => {
    const res = await api.baseAutorizeMe();
    const { status, result } = res;
    if (status === 200) {
      // 成功
      props.setAutorize(result);
    } else {
      props.setAutorize(null);
    }
  };

  /**
   * 获取用户基本信息
   */
  const getUserDetail = async () => {
    const res = await api.baseUserDetail();
    const { status, result } = res;
    if (status === 200) {
      // 成功
      props.setUserDetail(result);
      // analytics.setUserInfo({
      onUserLogin({
        ...result,
        role: result.roleList.map((item: any) => item.name).join(","),
      });
    } else {
      props.setUserDetail({});
    }
  };

  /**
   * 获取系统基本信息
   */
  const getBaseSystem = async () => {
    const res = await api.baseSystemConfig();
    const { status, result } = res;
    if (status === 200) {
      // 成功
      props.setSystem(result);
      localStorage.setItem(SYSTEM_CONFIG_FRONT_KEY, JSON.stringify(result));
      // setHeadData(result)
    } else {
      props.setSystem({});
      // setHeadData({})
    }
  };

  /**
   * 获取业务开关配置
   */
  const getConfigBusinessSwitch = async () => {
    const res = await api.baseSystemConfig(FIELD_NAME_BUSINESS_SWITCH);
    const { status, result } = res;
    if (status === 200) {
      setConfigBusinessSwitch(result);
    }
  };

  /**
   * 格式化菜单数据，将id->key, name->label
   * @param menusData 菜单数据
   * @returns 格式化好后的菜单数据
   */
  const formatMenusData = (menusData: any = []) => {
    return menusData.map((menu: any) => {
      const menuItem = cloneDeep(menu);
      const result: any = {};
      result.key = `${menuItem.id}_${menuItem.url}`;
      result.label = menuItem.name;
      result.icon = menuItem.icon ? (
        <i
          style={{ fontSize: 16 }}
          className={`icon iconfont ${menuItem.icon}`}
        />
      ) : (
        <></>
      );
      result.title = menuItem.name;
      if (menuItem?.children?.length) {
        result.children = formatMenusData(menuItem.children);
      }
      return result;
    });
  };

  /**
   * 格式化菜单数据->默认展开第一个数据
   * @param menusData 菜单数据
   * @returns 返回默认展开第一个的数据
   */
  const formatDefaultOpenKeys = (menusData: any = []) => {
    const result = menusData.filter((_menu: any, index: number) => index === 0);
    return result.map((item: { id: string; url: string }) => {
      return `${item.id}_${item.url}`;
    });
  };

  /**
   * 初始化页面时，当前路由匹配出菜单
   * @param menus 菜单列表
   * @param mode 当前导航模式（不能现取 getNavMode，避免切模式后首个渲染帧拿到旧值）
   * @returns 当前路由匹配到的菜单
   */
  const initMenuSelectedKeys: any = (menus: any, mode?: string) => {
    const ctx = {
      // 用 window.location 而不是 react-router 的 location：
      // 子应用 hash 路由内部跳转时主应用 BrowserRouter 不会收到通知，useLocation 会落后一帧甚至不更新
      pathname: window.location.pathname,
      hash: window.location.hash,
      menuType: mode || menuType,
      appName: BASE_SYSTEM_ENUM.APP_NAME,
    };
    const menuList = Array.isArray(menus) ? menus : [];
    // 同一路由可能命中多个菜单（父级 url 是子级前缀），findMenuChain 取最深、最具体的那条
    const chain = findMenuChain(menuList, ctx);
    if (!chain.length) {
      return { keys: [], selectedKeys: [], chain: [] };
    }
    // 选中链路上最细粒度且可跳转的节点，父级只用于顶部导航和树形展开
    let selectedIndex = chain.length - 1;
    for (let i = chain.length - 1; i >= 0; i--) {
      if (chain[i]?.url) {
        selectedIndex = i;
        break;
      }
    }
    const selectedNode = chain[selectedIndex];
    return {
      keys: [chain[0]],
      selectedKeys: [`${selectedNode.id}_${selectedNode.url}`],
      chain: chain.slice(0, selectedIndex + 1),
    };
  };

  /**
   * 选中当前的左侧菜单项，默认选中第一个
   * @param menus 菜单
   * @returns 选中的菜单key
   */
  const selectedCurrentKey = (menus: any = []) => {
    const result: any = [];
    const fn = (menus: any) => {
      let compareIndex = 0;
      for (let i = 0; i < menus.length; i++) {
        const curMenu = menus[i];
        if (i === compareIndex) {
          if (curMenu.urlType === "outside" && curMenu.urlTarget === "_blank") {
            compareIndex++;
            continue;
          }
          const menu = menus[i];
          if (menu?.children?.length) {
            fn(menu.children);
          } else {
            result.push(`${menu.id}_${menu.url}`);
            const truthUrl = getSubAppUrl(menu.url);
            if (truthUrl) {
              navigate(truthUrl);
            }
            break;
          }
        }
      }
    };
    fn(menus);
    return result;
  };

  /**
   * 当前地址是否已经落在某个子应用的具体页面上（不是子应用根路径）
   * 用于避免「匹配不到菜单」时把用户强行拉回默认菜单
   */
  const isInSubAppPage = () => {
    const { hash, pathname } = window.location;
    const hashPath = (hash || "").replace(/^#/, "").split("?")[0];
    const hashSegments = hashPath.split("/").filter(Boolean);
    if (hashSegments.length > 2) {
      // 例：#/khlinks/kh_access/device/Instance/Detail/123
      return true;
    }
    const pathSegments = (pathname || "").split("/").filter(Boolean);
    // history 模式子应用：/atomic-center/xxx
    return pathSegments.length > 1;
  };

  /**
   * 点击头部菜单事件
   * @param e 当前点击头部菜单的对象
   */
  const handleClickMenu = (e: { key: string }, selectedKey: boolean = true) => {
    if (e.key) {
      let urlType = "";
      let urlTarget = "";
      let url = "";
      for (const menu of props.base.menus) {
        if (menu.id === e.key) {
          urlType = menu.urlType;
          urlTarget = menu.urlTarget;
          url = menu.url;
        }
      }
      if (urlType === "outside" && urlTarget === "_blank" && url) {
        if (!url.startsWith("http")) {
          url =
            window.location.origin + (url.startsWith("/") ? url : `/${url}`);
        }
        window.open(
          url,
          urlTarget,
          "toolbar=yes, menubar=yes, scrollbars=yes, resizable=yes, location=yes, status=yes"
        );
        return;
      }
    }
    const result: any = [];
    e.key && result.push(e.key);
    let currentMenu = props.base.menus.filter(
      (menu: { id: string }) => menu.id === e.key
    );
    setTopMenuSelectedKeys(result);
    if (currentMenu.length) {
      currentMenu = getFilteredMenus(currentMenu);
      setOpenKeys(formatDefaultOpenKeys(currentMenu[0]?.children));
      props.setLeftMenu(currentMenu[0]);
      // 顶部导航点击时选中左侧第一个菜单；由路由匹配驱动的调用会显式传 false，
      // 因此这里不需要再判断当前路由是否已匹配（那个判断会导致点击顶部导航不跳转）
      if (selectedKey) {
        setLeftMenuSelectedKeys(selectedCurrentKey(currentMenu));
      }
    }
  };

  /**
   * 点击左侧菜单进行路由跳转
   * @param e 点击左侧菜单的数据
   */
  const handleClickLeftMenu = (e: any) => {
    const result: any = [];
    e.key && result.push(e.key);
    setLeftMenuSelectedKeys(result);
    const url = e.key.slice(e.key.indexOf("_") + 1, e.key.length);
    const truthUrl = getSubAppUrl(url);
    if (truthUrl) {
      navigate(truthUrl);
    }
    // actions.setGlobalState({
    //   breadcrumbItems: []
    // });
  };

  /**
   * 点击切换菜单列表/工作台模式
   */
  const handleClickChangeModel = () => {
    // MENU_SHOW_MODE  card：工作台模式   menu：菜单模式
    // modal.confirm({
    //   title: '确认提示',
    //   icon: <ExclamationCircleOutlined />,
    //   content: `确定切换成${menuType === 'menu' ? '卡片' : '列表'}模式吗？`,
    //   okText: '确认',
    //   cancelText: '取消',
    //   onOk: function(close) {
    //     close();
    //     swapNavMode();
    //     setMenuType(getNavMode());
    //   },
    //   onCancel: function(close) {
    //     close();
    //   }
    // });
    swapNavMode();
    setMenuType(getNavMode());
  };

  /**
   * 返回首页
   */
  // const handleClickGoHome = () => {
  //   navigateSubApp('/home/index');
  // };

  /**
   * 加载消息条数
   */
  const initNoticelData = async () => {
    const res = await api.baseNotices(
      encodeQuery({
        terms: { state: "unread" },
        sorts: { notifyTime: "desc" },
      })
    );

    if (res.status === 200) {
      props.setNotifications(res.result);
    }
  };
  const [cardUpdateCode, setCardUpdateCode] = useState("");

  const getBreadcrumbTitleText = (title: any): string => {
    if (typeof title === "string" || typeof title === "number") {
      return String(title);
    }
    if (Array.isArray(title)) {
      return title.map((item) => getBreadcrumbTitleText(item)).join("");
    }
    // 兼容 ReactNode（如 <a>规则运行日志</a>），避免 document.title 出现 [object Object]
    if (
      title &&
      typeof title === "object" &&
      title.props?.children !== undefined
    ) {
      return getBreadcrumbTitleText(title.props.children);
    }
    return "";
  };

  const isMenuMatchedByLocation = (menuUrl: string) => {
    if (!menuUrl) {
      return false;
    }
    // 面包屑只关心“落在哪个菜单”，与卡片/菜单模式无关，
    // 统一按包含关系匹配，避免菜单模式下详情页面包屑丢失
    return matchMenuUrl(menuUrl, {
      pathname: window.location.pathname,
      hash: window.location.hash,
      menuType: MATCH_CARD_MODE,
      appName: BASE_SYSTEM_ENUM.APP_NAME,
    });
  };

  const getMenuBreadcrumbItems = (menus: any[] = []) => {
    let bestMatchedChain: any[] = [];
    const walkMenus = (menuList: any[] = [], parentChain: any[] = []) => {
      menuList.forEach((menu) => {
        const currentChain = [...parentChain, menu];
        if (isMenuMatchedByLocation(menu.url)) {
          const currentUrlLength = menu.url?.length || 0;
          const bestLastMenu = bestMatchedChain[bestMatchedChain.length - 1];
          const bestUrlLength = bestLastMenu?.url?.length || 0;
          if (
            currentChain.length > bestMatchedChain.length ||
            (currentChain.length === bestMatchedChain.length &&
              currentUrlLength > bestUrlLength)
          ) {
            bestMatchedChain = currentChain;
          }
        }
        if (menu?.children?.length) {
          walkMenus(menu.children, currentChain);
        }
      });
    };
    walkMenus(menus);
    return bestMatchedChain.map((menu, index) => ({
      title: menu.name,
      path:
        index < bestMatchedChain.length - 1 && menu.url
          ? menu.url
          : undefined,
    }));
  };

  const isSubAppBreadcrumbIncludesMenu = (
    subAppBreadcrumbItems: any[],
    menuBreadcrumbItems: any[]
  ) => {
    if (!subAppBreadcrumbItems.length || !menuBreadcrumbItems.length) {
      return false;
    }
    if (subAppBreadcrumbItems.length >= menuBreadcrumbItems.length) {
      return true;
    }
    return subAppBreadcrumbItems.some((item: any, index: number) => {
      const menuItem = menuBreadcrumbItems[index];
      if (!menuItem) {
        return false;
      }
      if (
        item &&
        typeof item === "object" &&
        item.path &&
        menuItem.path &&
        item.path === menuItem.path
      ) {
        return true;
      }
      const itemTitle =
        item && typeof item === "object"
          ? getBreadcrumbTitleText(item.title)
          : getBreadcrumbTitleText(item);
      return itemTitle === menuItem.title;
    });
  };

  const normalizeBreadcrumbItems = (subAppBreadcrumbItems: any[] = []) => {
    const menuBreadcrumbItems = getMenuBreadcrumbItems(menusRef.current);
    if (!menuBreadcrumbItems.length) {
      return subAppBreadcrumbItems;
    }
    if (!subAppBreadcrumbItems.length) {
      return menuBreadcrumbItems;
    }

    const includesMenuBreadcrumb = isSubAppBreadcrumbIncludesMenu(
      subAppBreadcrumbItems,
      menuBreadcrumbItems
    );
    const pageLevelItems = includesMenuBreadcrumb
      ? subAppBreadcrumbItems.slice(menuBreadcrumbItems.length)
      : subAppBreadcrumbItems;

    const mergedMenuBreadcrumbItems = menuBreadcrumbItems.map(
      (menuItem, index) => {
        const sourceItem = subAppBreadcrumbItems[index];
        // const defaultPath =
        //   index < menuBreadcrumbItems.length - 1 ? menuItem.path : undefined;
        if (sourceItem && typeof sourceItem === "object") {
          return {
            ...sourceItem,
            title: menuItem.title,
            // path: sourceItem.path || defaultPath,
          };
        }
        return {
          title: menuItem.title,
          // path: defaultPath,
        };
      }
    );
    return [...mergedMenuBreadcrumbItems, ...pageLevelItems];
  };

  const updateBreadcrumbView = (subAppBreadcrumbItems: any[] = []) => {
    const finalBreadcrumbItems = normalizeBreadcrumbItems(subAppBreadcrumbItems);
    if (finalBreadcrumbItems.length) {
      const title = finalBreadcrumbItems
        ?.map((item: any) =>
          getBreadcrumbTitleText(
            item && typeof item === "object" ? item.title : item
          )
        )
        .filter(Boolean)
        .join(" - ");
      if (title && title !== document.title) {
        document.title = title;
      }
      setBreadcrumbItems(finalBreadcrumbItems);
    } else {
      setBreadcrumbItems([]);
    }
  };

  const init = async () => {
    //fix：解决刷新主题颜色问题，登录成功后，保存当前主题颜色,改变主题颜色需要退出重新登录
    setHeadData({
      headerTheme: localStorage.getItem("SYSTEM_THEME") || "dark",
    });
    try {
      await getBaseSystem();
      await getConfigBusinessSwitch();
    } catch (error) {
      console.error(error);
    }
    getBaseUserOwnTree();
    getBaseAutorizeMe();
    getUserDetail();
    setMenuType(getNavMode());
    initNoticelData();
  };

  // 获取三方跳转url中的token并存入，后删除url中的token
  const handleThirdPartyLogin = () => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("thirdPartyToken");
    console.log("base thirdPartyToken: ", token);
    if (token) {
      Token.set(token);
      url.searchParams.delete("thirdPartyToken");
      window.location.replace(url.toString());
      return true;
    }
    return false;
  };

  useEffect(() => {
    // 三方登录处理
    const isThirdPartyLoginRedirecting = handleThirdPartyLogin();
    if (isThirdPartyLoginRedirecting) {
      return;
    }

    init();
    actions.onGlobalStateChange((state, prev) => {
      // 设置面包屑
      const subAppBreadcrumbItems = Array.isArray(state.breadcrumbItems)
        ? state.breadcrumbItems
        : [];
      latestSubAppBreadcrumbRef.current = subAppBreadcrumbItems;
      updateBreadcrumbView(subAppBreadcrumbItems);
      const { cardUpdate, notificationUpdate, navigateConfig } = state;
      const {
        cardUpdate: cardUpdatePrev,
        notificationUpdate: notificationUpdatePrev,
        navigateConfig: navigateConfigPrev,
      } = prev;
      // 处理卡片更新事件
      if (
        cardUpdate.timestamp &&
        (!cardUpdatePrev.timestamp ||
          cardUpdate.timestamp > cardUpdatePrev.timestamp)
      ) {
        setCardUpdateCode(cardUpdate.code + cardUpdate.timestamp);
      }
      // 处理告警更新事件
      if (
        notificationUpdate.timestamp &&
        (!notificationUpdatePrev.timestamp ||
          notificationUpdate.timestamp > notificationUpdatePrev.timestamp)
      ) {
        initNoticelData();
        //自动弹出告警弹框
        if (notificationUpdate?.isShowNotification) {
          props.setNotificationsOpen(notificationUpdate.isShowNotification);
        }
      }
      // 处理子应用跳转事件
      if (
        navigateConfig.timestamp &&
        navigateConfig.path &&
        (!navigateConfigPrev.timestamp ||
          navigateConfig.timestamp > navigateConfigPrev.timestamp)
      ) {
        // 执行跳转逻辑
        navigate(getSubAppUrl(navigateConfig.path));
      }
    });
    // 监听localStorage变化，处理用户信息更新事件
    window.addEventListener("storage", (event) => {
      if (event.storageArea === localStorage) {
        // 用户信息发生变化，需要刷新菜单数据
        if (event.key === "USER_INFO" && event.oldValue !== event.newValue) {
          // 当用户信息发生变化，刷新页面
          window.location.reload();
        }
      }
    });
  }, []);

  useEffect(() => {
    updateBreadcrumbView(latestSubAppBreadcrumbRef.current);
  }, [props?.base?.menus, location, menuType]);

  // 处理菜单选中交互
  // @param mode 显式传入当前导航模式，切换卡片/菜单模式后首个渲染帧也按新模式匹配
  const handleMenuSelect = (mode?: string) => {
    if (!props?.base?.menus?.length) {
      return;
    }
    const { keys, selectedKeys, chain } = initMenuSelectedKeys(
      props.base.menus,
      mode
    );
    if (keys?.length && selectedKeys?.length) {
      // 只切换顶部导航和左侧菜单数据，不要覆盖成"第一个菜单"
      handleClickMenu({ key: keys[0].id }, false);
      setLeftMenuSelectedKeys(selectedKeys);
      // 展开当前菜单的祖先节点，否则树形菜单里选中项会被折叠看不见，
      // 视觉上就像"回到了默认菜单"
      const ancestorKeys: string[] = chain
        .slice(0, -1)
        .map((menu: any) => (menu?.url ? `${menu.id}_${menu.url}` : ""))
        .filter(Boolean);
      if (ancestorKeys.length) {
        setOpenKeys(ancestorKeys);
      }
      return;
    }
    // 已经停留在子应用的某个具体页面上（如详情页）却匹配不到菜单时，
    // 保持现有选中状态。这里一旦回退就会把用户拉回默认菜单，是本次问题的直接原因。
    if (isInSubAppPage()) {
      return;
    }
    if (localStorage.getItem("INIT_SYSTEM") === "1") {
      return;
    }
    const truthUrl = getSubAppUrl(getInitUrl(props.base.menus) || "");
    if (!truthUrl) {
      return;
    }
    const currentUrl = window.location.pathname + window.location.hash;
    if (currentUrl.includes(truthUrl) || truthUrl === currentUrl) {
      return;
    }
    navigate(truthUrl);
  };

  // 监听路由变化，处理相应更新事件
  useEffect(() => {
    if (props?.base?.menus?.length === 0) {
      return;
    }
    handleMenuSelect();
  }, [location]);

  // 初始化页面时，当前路由匹配出导航和菜单及选中状态
  useEffect(() => {
    if (props?.base?.menus?.length === 0) {
      return;
    }
    handleMenuSelect();
  }, [props.base.menus]);

  /**
   * 切换卡片/菜单模式后重新匹配菜单选中状态
   * 两种模式的匹配规则不同（菜单模式按路径段前缀，卡片模式按包含），
   * 不重新匹配会导致从详情页切回菜单模式时选中项错乱/回到默认第一项。
   */
  useEffect(() => {
    if (props?.base?.menus?.length === 0 || !menuType) {
      return;
    }
    handleMenuSelect(menuType);
  }, [menuType]);

  /**
   * 子应用（hash 路由）内部跳转时，主应用 BrowserRouter 的 location 不会变化，
   * useEffect([location]) 不会触发。这里直接监听 hashchange 同步菜单选中状态，
   * 保证从列表进入详情页后左侧菜单仍然停留在原来的菜单项上。
   */
  useEffect(() => {
    const syncMenuByHash = () => {
      locationRef.current = window.location as any;
      if (props?.base?.menus?.length) {
        handleMenuSelect();
      }
    };
    window.addEventListener("hashchange", syncMenuByHash);
    return () => {
      window.removeEventListener("hashchange", syncMenuByHash);
    };
  }, [props?.base?.menus, menuType]);

  //登录成功后，校验license到期状态，剩余30天，弹框提示
  useEffect(() => {
    if (isLogin) {
      api.getLicenseNotifyInfo().then((res: any) => {
        if (res.status === 200) {
          setIsNotify(res?.result?.needNotify);
          setNotifyInfo(res?.result?.notifyInfo || "");
        }
      });
    }
  }, [isLogin]);

  /**
   * 根据菜单类型分别渲染
   * @returns menu
   */
  const siderMenuRender = () => {
    switch (menuType) {
      case MENU_MODE: // 菜单模式
        return (
          <Menu
            theme={headData?.headerTheme}
            mode="inline"
            openKeys={openKeys}
            selectedKeys={leftMenuSelectedKeys}
            items={formatMenusData(props?.base?.leftMenus?.children)}
            style={{ height: "100%", borderRight: 0 }}
            onClick={handleClickLeftMenu}
            onOpenChange={(keys: any) => {
              setOpenKeys(keys);
            }}
          />
        );
      case CARD_MODE: // 卡片模式
        return (
          <MenuWorkbench
            theme={headData?.headerTheme}
            menuData={props?.base?.leftMenus?.children}
            onEntryClick={() => onCollapse(!collapsed)}
            cardUpdateCode={cardUpdateCode}
          />
        );
      default:
        console.warn(`未知的菜单类型：${menuType}`);
    }
  };

  // 左侧导航的classname
  const siderClassName = `${TWBasePrefixCls}-sider ${TWBasePrefixCls}-sider_${menuType}`;

  /**
   * 显示切换工作台的按钮图标
   * 管理员才会显示。目前后端的方案只有通过固定的user id来判断
   * 1199596756811550720 代表为管理员
   * @returns dom
   */
  const headerRightChangeModelRender = () => {
    return props?.base?.autorize?.user?.id === "1199596756811550720" ? (
      <SwapOutlined
        className={`${TWBasePrefixCls}-header-right_btn`}
        onClick={handleClickChangeModel}
      />
    ) : (
      <></>
    );
  };

  /**
   * 面包屑
   * @returns dom
   */
  const breadcrumbItemRender = () => {
    return breadcrumbItems.map(
      (item: any, index) => {
        const title =
          item && typeof item === "object" ? item.title : item;
        const path = item && typeof item === "object" ? item.path : undefined;
        // 包含path的走此分支
        if (path) {
          return (
            <Breadcrumb.Item key={index}>
              <a
                href="javascript: void(0)"
                onClick={() => {
                  const truthUrl = getSubAppUrl(path);
                  if (truthUrl) {
                    navigate(truthUrl);
                  }
                }}
              >
                {title}
              </a>
            </Breadcrumb.Item>
          );
        }
        return <Breadcrumb.Item key={index}>{title}</Breadcrumb.Item>;
      }
    );
  };

  const breadcrumbRender = () => {
    return breadcrumbItems.length ? (
      <Breadcrumb
        style={{ margin: "8px 0", padding: "0 48px", lineHeight: "20px" }}
      >
        {breadcrumbItemRender()}
      </Breadcrumb>
    ) : (
      <></>
    );
  };

  return (
    <>
      {isLogin ? (
        <div
          className={`${
            headData?.headerTheme
              ? "theme-" + headData?.headerTheme
              : "theme-dark"
          }`}
        >
          <Layout style={{ height: "100%", flexDirection: "column" }}>
            <Header className={`${TWBasePrefixCls}-header`}>
              <div className={`${TWBasePrefixCls}-logo`}>
                <img src={props.base?.system?.logo || LogoKaihong} />
                <h1>
                  {props.base?.system?.title || BASE_SYSTEM_ENUM.SYSTEM_NAME}
                </h1>
              </div>
              <div className={`${TWBasePrefixCls}-header-menu`}>
                <Menu
                  theme={headData?.headerTheme === "light" ? "light" : "dark"}
                  mode="horizontal"
                  onClick={handleClickMenu}
                  selectedKeys={topMenuSelectedKeys}
                  items={props.base.menus.map((item: any) => {
                    return {
                      key: item.id,
                      label: item.name,
                      icon: item.icon ? (
                        <i
                          style={{ fontSize: 16 }}
                          className={`icon iconfont ${item.icon}`}
                        />
                      ) : (
                        <></>
                      ),
                    };
                  })}
                />
              </div>
              <div className={`${TWBasePrefixCls}-header-right`}>
                <Space size={20}>
                  <TenantSwitch />
                  {/* 切换菜单模式 */}
                  {headerRightChangeModelRender()}

                  {/* 返回首页 */}
                  {/* <HomeOutlined
                className={`${TWBasePrefixCls}-header-right_btn`}
                onClick={handleClickGoHome}
              /> */}

                  <Popover
                    trigger="click"
                    placement="bottomRight"
                    overlayInnerStyle={{ padding: 0 }}
                    content={<Noticel />}
                    open={props.base.notificationOpen}
                    onOpenChange={(newOpen: boolean) => {
                      props.setNotificationsOpen(newOpen);
                    }}
                  >
                    <div>
                      <Badge
                        size="small"
                        count={props.base.notifications?.total || 0}
                      >
                        <BellOutlined
                          className={`${TWBasePrefixCls}-header-right_btn`}
                        />
                      </Badge>
                    </div>
                  </Popover>

                  <Dropdown
                    menu={{ items }}
                    placement="bottomLeft"
                    overlayStyle={{ minWidth: 120 }}
                  >
                    <div className={`${TWBasePrefixCls}-header-right_avatar`}>
                      {props.base?.userDetail?.avatar ? (
                        <Avatar
                          src={
                            <img
                              src={props.base?.userDetail?.avatar}
                              alt="avatar"
                            />
                          }
                        />
                      ) : (
                        <Avatar
                          size="small"
                          icon={<UserOutlined />}
                          style={{
                            backgroundColor: "#fde3cf",
                            color: "#f56a00",
                          }}
                        />
                      )}
                      <span
                        className={`${TWBasePrefixCls}-header-right_avatar_name`}
                      >
                        {props.base.autorize?.user?.name || ""}
                      </span>
                    </div>
                  </Dropdown>
                </Space>
              </div>
            </Header>
            <Layout className={`${TWBasePrefixCls}-wrap`}>
              <Sider
                className={siderClassName}
                trigger={
                  menuType === CARD_MODE ? null : collapsed ? (
                    <div>
                      <Divider style={{ margin: 0 }} />
                      <MenuUnfoldOutlined />
                    </div>
                  ) : (
                    <div>
                      <Divider style={{ margin: 0 }} />
                      <MenuFoldOutlined />
                    </div>
                  )
                }
                collapsible
                collapsed={collapsed}
                collapsedWidth={menuType === CARD_MODE ? 0 : 50}
                width={menuType === CARD_MODE ? 420 : 210}
                theme={headData?.headerTheme}
                onCollapse={onCollapse}
              >
                <div style={{ height: "100%" }}>{siderMenuRender()}</div>
              </Sider>
              <Layout className={`${TWBasePrefixCls}-wrap_right`}>
                <Spin
                  spinning={props.base.BASE_MAIN_ROOT_ISLOADING}
                  delay={500}
                >
                  {/* 面包屑 */}
                  {breadcrumbRender()}

                  {/* 子应用容器 */}
                  <Content
                    id="main-container"
                    className={`${TWBasePrefixCls}-app-container`}
                    style={{
                      padding: 0,
                      margin: 0,
                      minHeight: 450,
                    }}
                  />
                </Spin>
                {isNotify && (
                  <NotifyInfo
                    data={notifyInfo}
                    onCancel={() => {
                      setIsNotify(false);
                    }}
                  />
                )}
              </Layout>
            </Layout>
          </Layout>
        </div>
      ) : isNetError ? (
        <NetError />
      ) : (
        <Spin size="large" />
      )}
    </>
  );
}

const mapStateToProps = (state: any) => {
  return state;
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    // 设置菜单数据
    setMenu: (data: any) => {
      dispatch({
        type: BASE_SET_MENU,
        data,
      });
    },
    // 设置左侧菜单
    setLeftMenu: (data: any) => {
      dispatch({
        type: BASE_SET_LEFT_MENU,
        data,
      });
    },
    // 设置用户基本信息
    setAutorize: (data: any) => {
      dispatch({
        type: BASE_SET_AUTORIZE,
        data,
      });
    },
    setUserDetail: (data: any) => {
      dispatch({
        type: BASE_SET_USER_DETAIL,
        data,
      });
    },
    // 设置系统基本信息
    setSystem: (data: any) => {
      dispatch({
        type: BASE_SET_SYSTEM,
        data,
      });
    },
    // 设置系统基本信息
    setNotifications: (data: any) => {
      dispatch({
        type: BASE_SET_NOTIFICATIONS,
        data,
      });
    },
    // 设置告警消息弹窗状态
    setNotificationsOpen: (data: any) => {
      dispatch({
        type: BASE_SET_NOTIFICATION_OPEN,
        data,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
